/* Nilo locale gate; uses native Shopify localization form. */
(function(){'use strict';
 var gate=document.querySelector('[data-nilo-lang-gate]');if(!gate)return;
 var key='nilo-v51348-language-chosen',storage;
 try{storage=window.localStorage}catch(_){storage=null}
 function stored(){try{return storage&&storage.getItem(key)}catch(_){return null}}
 function mark(v){try{if(storage)storage.setItem(key,v)}catch(_){}}
 var current=gate.getAttribute('data-current-locale')||'fr';
 var form=gate.querySelector('form'),input=gate.querySelector('[data-nilo-lang-locale]');
 function show(){gate.hidden=false;document.documentElement.classList.add('nilo-lang-gate-open');var b=gate.querySelector('[data-nilo-lang-value="'+(current.indexOf('ar')===0?'ar':'fr')+'"]');if(b)b.focus({preventScroll:true});}
 function close(){gate.hidden=true;document.documentElement.classList.remove('nilo-lang-gate-open')}
 gate.addEventListener('click',function(ev){var b=ev.target.closest&&ev.target.closest('[data-nilo-lang-value]');if(!b)return;var val=b.dataset.niloLangValue;if(val!=='fr'&&val!=='ar')return;
 mark(val);close();if(current.split('-')[0]===val)return;if(!form||!input)return;input.value=val;form.submit();});
 document.addEventListener('click',function(ev){if(ev.target.closest&&ev.target.closest('[data-nilo-lang-switch-open]'))show()});
 if(!stored())show();
})();
